import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

const ItemsIcon = React.forwardRef<SVGSVGElement, Props>((props, ref) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M11.1615 22C10.9111 22 10.6608 21.95 10.4105 21.85C10.1602 21.75 9.93492 21.6 9.73467 21.4L2.57572 14.25C2.37547 14.05 2.22945 13.8292 2.13767 13.5875C2.04589 13.3458 2 13.1 2 12.85C2 12.6 2.04589 12.35 2.13767 12.1C2.22945 11.85 2.37547 11.625 2.57572 11.425L11.3867 2.6C11.5703 2.41667 11.7872 2.27083 12.0375 2.1625C12.2879 2.05417 12.5465 2 12.8135 2H19.9975C20.5482 2 21.0196 2.19583 21.4118 2.5875C21.8039 2.97917 22 3.45 22 4V11.175C22 11.4417 21.9499 11.6958 21.8498 11.9375C21.7497 12.1792 21.6078 12.3917 21.4243 12.575L12.5882 21.4C12.388 21.6 12.1627 21.75 11.9124 21.85C11.6621 21.95 11.4118 22 11.1615 22ZM11.1615 20L19.9975 11.15V4H12.8385L4.0025 12.85L11.1615 20ZM17.4944 8C17.9116 8 18.2662 7.85417 18.5582 7.5625C18.8502 7.27083 18.9962 6.91667 18.9962 6.5C18.9962 6.08333 18.8502 5.72917 18.5582 5.4375C18.2662 5.14583 17.9116 5 17.4944 5C17.0772 5 16.7226 5.14583 16.4305 5.4375C16.1385 5.72917 15.9925 6.08333 15.9925 6.5C15.9925 6.91667 16.1385 7.27083 16.4305 7.5625C16.7226 7.85417 17.0772 8 17.4944 8Z"
      fill="currentColor"
    />
  </svg>
));

ItemsIcon.displayName = 'ItemsIcon';

export default ItemsIcon;
